export default __webpack_public_path__ + "static/media/Outfit-ExtraLight.04595e07.ttf";